import React, {useContext, useEffect, useState} from "react";
import {AppContext} from "../../lib/AppContext";
import {Col, Container, Row} from "react-bootstrap";
import {getReferralTypes, getStates} from "./api/PortalCustomerApi";
import {useNavigate} from "react-router-dom";
import {useForm} from "react-hook-form";
import {checkFormValidity, displayPhone, handleDefaultValues} from "./Utils";
import {createProfile} from "./api/PortalCustomerApi";
import MDButton from "../../components/MDButton";
import MDInput from "../../components/MDInput";
import {NativeSelect} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import {UserContext} from "../../lib/UserProvider";
import MDTypography from "../../components/MDTypography";
import Divider from "@mui/material/Divider";
import ErrorIcon from '@mui/icons-material/Error';
import {MenuContext} from "../../lib/MenuProvider";

export default function CreateAccount(props) {

  const PASS_MIN_LENGTH = 8;
  const [context, setContext] = useContext(AppContext);
  const [userContext, setUserContext] = useContext(UserContext);
  const [menuContext, setMenuContext] = useContext(MenuContext);

  const [showLogin, setShowLogin] = useState(false);
  const [username, setUsername] = useState('');
  const [passwd, setPasswd] = useState('');
  const [passwd2, setPasswd2] = useState('');
  const [passwdError, setPasswdError] = useState(false);
  const [passwdComplex, setPasswdComplex] = useState(false);
  const [passwdComplexMessage, setPasswdComplexMessage] = useState('');

  const [showAddress, setShowAddress] = useState(false);
  const [loggingIn, setLoggingIn] = useState(false);
  const [loginError, setLoginError] = useState(null);
  const [createAccount, setCreateAccount] = useState(props?.createAccount || false);
  const [states, setStates] = useState([]);
  const [referralTypes, setReferralTypes] = useState([]);
  const [statesReady, setStatesReady] = useState(false);
  const [formInvalid, setFormInvalid] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(false);
  const [invalidEmail, setInvalidEmail] = useState(false);

  const [card, setCard] = useState(null);
  const [expyError, setExpyError] = useState(false);

  const passComplexity = (password) => {
    const passErrors = [];

    if (password.length < 8) {
      passErrors.push("at least 8 characters");
    }

    if (!/[a-z]/.test(password)) {
      passErrors.push("a lowercase letter");
    }

    if (!/[A-Z]/.test(password)) {
      passErrors.push("an uppercase letter");
    }

    if (!/\d/.test(password)) {
      passErrors.push("a number");
    }

    if (!/[^\w\s]/.test(password)) {
      passErrors.push("a special character");
    }

    setPasswdComplex(passErrors.length === 0);
    setPasswdComplexMessage(
      passErrors.length > 0
        ? `Password must contain ${passErrors.join(", ")}.`
        : ""
    );

  }

  useEffect(() => {
    if (!card?.isValid) {
      setFormInvalid(true);
    }
  }, [card]);

  const [customer, setCustomer] = useState();
  const {register, handleSubmit, setValue, control, reset} = useForm({
    values: handleDefaultValues(customer),
  });

  const handleSaveCustomer = async (customer) => {

    setSaving(true);
    setError(false);
    let c = {...customer};

    let result = await createProfile(c);

    setSaving(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
      setError(result.message);
    } else {
      setUserContext({...userContext, refreshIdentity: true, sessionUser: result});
      setMenuContext({...menuContext, refreshContext: true});

      props.handleSave();
    }
  }

  useEffect(() => {
    getReferralTypes().then(result => {
      setReferralTypes(result);
    });
    getStates().then(result => {
      setStates(result);
    });
  }, []);

  return (
    <>
      <div>
        <form
          onChange={(e) => setFormInvalid(!!!checkFormValidity(e))}
          onSubmit={handleSubmit(handleSaveCustomer)} id={'customerForm'}>
          <Container>
            <Row>
              <Col className={'col my-2'} sm={6} xs={12}>
                <div className="form-group">
                  <MDInput type="text" required
                           variant="outlined"
                           {...register('firstName')}
                           autoComplete="off"
                           className="form-control" id="firstName"
                           InputLabelProps={{shrink: true}}
                           placeholder="Enter First Name"
                           label="First name"/>
                </div>
              </Col>

              <Col className={'col my-2'} sm={6} xs={12}>
                <div className="form-group">
                  <MDInput type="text" required
                           variant="outlined"
                           {...register('lastName')}
                           className="form-control" id="lastName"
                           InputLabelProps={{shrink: true}}
                           placeholder="Enter Last Name"
                           label="Last name"/>
                </div>
              </Col>
            </Row>
            <Row>
              <Col className={'col my-2'} md={6} sm={12} xs={12}>
                <div className="form-group">
                  <MDInput type="email" required
                           {...register('email', {
                             onChange: (e) => {
                               let email = e.target.value;
                               let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                               setInvalidEmail(!re.test(email));
                             }
                           })}
                           autoComplete="off"
                           variant="outlined"
                           className="form-control" id="email"
                           InputLabelProps={{shrink: true}}
                           placeholder="Enter Email"
                           label="Email"/>
                  <label htmlFor="emailEnabled">
                    <Checkbox defaultChecked={true}
                              {...register('emailEnabled')}
                              id="emailEnabled"/>
                    &nbsp;Email Allowed
                  </label>
                </div>
              </Col>

              <Col className={'col my-2'} md={6} sm={12} xs={12}>
                <div className="form-group">
                  <MDInput type="text" required
                           {...register('primaryPhone', {
                             onChange: (e) => {
                               e.target.value = displayPhone(e.target.value);
                             }
                           })}
                           variant="outlined"
                           autoComplete="off"
                           className="form-control" id="primaryPhone"
                           InputLabelProps={{shrink: true}}
                           placeholder="Enter Phone"
                           label="Phone"/>

                  <label htmlFor="smsEnabled">
                    <Checkbox defaultChecked={true}
                              {...register('smsEnabled')}
                              id="smsEnabled"/>
                    &nbsp;SMS Allowed
                  </label>
                </div>
              </Col>
            </Row>

            <Row>
              <Col className={'col my-2'} md={6} sm={12} xs={12}>
                <div className="form-group">
                  <MDInput type="password" required
                           {...register('passwd', {
                             onChange: (e) => {
                               setPasswd(e.target.value);
                               setPasswdError(false);
                               passComplexity(e.target.value);
                               if (passwd.length < PASS_MIN_LENGTH) {
                                 setPasswdError(true);
                               }
                             }
                           })}
                           autoComplete="off"
                           variant="outlined"
                           className="form-control" id="passwd"
                           InputLabelProps={{shrink: true}}
                           placeholder="Password"
                           label="Enter Password"/>
                </div>
              </Col>

              <Col className={'col my-2'} md={6} sm={12} xs={12}>
                <div className="form-group">
                  <div className="form-group">
                    <MDInput type="password" required
                             {...register('passwd2', {
                               onChange: (e) => {
                                 setPasswd2(e.target.value);
                                 if (passwd !== e.target.value) {
                                   setPasswdError(true);
                                 }
                               }
                             })}
                             autoComplete="off"
                             variant="outlined"
                             className="form-control" id="passwd2"
                             InputLabelProps={{shrink: true}}
                             placeholder="Confirm Password"
                             label="Re-Enter Password"/>
                  </div>
                </div>
              </Col>
            </Row>
            {passwdError && <Row>
              <Col className={'col my-2'} xs={12}>
                <MDTypography variant="p" color="warning" fontWeight="regular">
                  {passwd !== passwd2 && <p>Passwords do not match</p>}
                  {/*{passwd2.length > 0 && passwd.length < PASS_MIN_LENGTH &&*/}
                  {/*  <p>Password must be at least {PASS_MIN_LENGTH} characters</p>}*/}
                  {!passwdComplex && <p><b>Please choose a stronger password</b><br/>
                    {passwdComplexMessage}</p>}
                </MDTypography>
              </Col>
            </Row>}


            {'true' === context?.sessionUser?.company?.preferences['require_address'] && <>
              <Row>
                <Col className={'col my-2'} sm={6} xs={12} className={'my-2'}>
                  <div className="form-group">
                    <MDInput type="text" required
                             variant="outlined"
                             {...register('address1')}
                             autoComplete="off"
                             className="form-control" id="address1"
                             InputLabelProps={{shrink: true}}
                             placeholder="Address"
                             label="Enter Address"/>
                  </div>
                </Col>

                <Col className={'col my-2'} sm={6} xs={12}>
                  <div className="form-group">
                    <MDInput type="text"
                             variant="outlined"
                             {...register('address2')}
                             autoComplete="off"
                             className="form-control" id="address2"
                             InputLabelProps={{shrink: true}}
                             placeholder="Address 2"
                             label="Enter Address 2"/>
                  </div>
                </Col>
              </Row>

              <Row className={'mt-2'}>
                <Col className={'col my-2'} sm={4} xs={12}>
                  <div className="form-group">
                    <MDInput type="text" required
                             variant="outlined"
                             {...register('city')}
                             autoComplete="off"
                             className="form-control" id="city"
                             InputLabelProps={{shrink: true}}
                             placeholder="City"
                             label="Enter City"/>
                  </div>
                </Col>

                <Col className={'col my-2'} sm={4} xs={12}>
                  <div className="form-group">
                    {states?.length > 0 && <NativeSelect
                      variant="standard" required
                      label="State"
                      id={'state'} name={'state'} className={'form-control'}
                      {...register('state.stateId')}
                      defaultValue={states[0].stateId}>
                      {
                        states?.map((c) =>
                          <option value={c.stateId} key={c.stateId}>
                            {c.stateName}
                          </option>)
                      }
                    </NativeSelect>}
                  </div>
                </Col>

                <Col className={'col my-2'} sm={4} xs={12}>
                  <div className="form-group">
                    <MDInput type="text" required
                             variant="outlined"
                             {...register('zipCode')}
                             autoComplete="off"
                             className="form-control" id="zipCode"
                             InputLabelProps={{shrink: true}}
                             placeholder="Zip"
                             label="Enter Zip"/>
                  </div>
                </Col>
              </Row>
            </>}


            <Row>
              <Col className={'col my-2'} sm={8} xs={12}>
                <div className="form-group justify-content-center">
                  {referralTypes?.length > 0 && <>
                    <p>How did you hear about
                      us? {'true' === context?.sessionUser?.company?.preferences['require_referral_type'] && '*'}</p>
                    <NativeSelect
                      required={'true' === context?.sessionUser?.company?.preferences['require_referral_type']}
                      variant="standard"
                      id={'referralType'} name={'referralType'} className={'form-control'}
                      {...register('referralType.id', {
                        required: 'true' === context?.sessionUser?.company?.preferences['require_referral_type'],
                        min: 'true' === context?.sessionUser?.company?.preferences['require_referral_type'] ? 0 : -1
                      })}
                      defaultValue={-1}>
                      <option value={-1}>Choose</option>
                      {
                        referralTypes?.map((c) =>
                          <option value={c.id} key={c.id}>
                            {c.name}
                          </option>)
                      }
                    </NativeSelect></>
                  }
                </div>
              </Col>
            </Row>
            <center>
              <MDButton type="submit" color="info"
                        style={{
                          float: 'right'
                        }}
                        disabled={formInvalid || invalidEmail || !passwdComplex || (passwd !== passwd2) || saving}>
                {saving ? 'Saving...' : 'Save'}
              </MDButton>
            </center>
            {error && <div style={{
              display: 'block',
              clear: 'both',
              textAlign: 'center',
              color: "#ff0000",
              fontWeight: 'bold'
            }}><p className="d-block text-error">
              <ErrorIcon/> {error}
            </p></div>}
          </Container>
        </form>
      </div>
    </>
  )
}